export default "../css/8a89cdd9af15688297c86e4e02486246.ttf";